module.exports = __webpack_public_path__ + "img/aba_mobile.0bdeda2b.png";